import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Working = () => {
  const steps = [
    {
      number: "1",
      title: "Teach Nouraa about your business",
      description:
        "Getting started is effortless—just enter your website address or provide basic clinic details to set up your account. No complicated setup or technical expertise is needed!",
    },
    {
      number: "2",
      title: "Set your preferences",
      description:
        "Easily customize Nouraa to handle calls your way—set responses, scheduling preferences, and tailored interactions. From booking appointments to answering FAQs, Nouraa adapts seamlessly to your workflow.",
    },
    {
      number: "3",
      title: "Let Nouraa Do the Work",
      description:
        "Get real-time updates via email or text, so you never miss an important interaction. Every conversation is securely stored in your call inbox for easy review and management.",
    },
  ];

  return (
    <Container fluid className="mb-5">
      <Container>
        <h1 className="text-center fw-bold fs-four-title anybody-font my-4">
          How Does It Work?
        </h1>
        <p className="text-center fs-two gray-color mb-5">
          Sign In & Set Up in less than 5 mins. No technical skills are required
          to set things up!
        </p>
        <Row className="align-items-center">
          <Col md={6} className="text-section">
            {steps.map((step, index) => (
              <div key={index} className="d-flex align-items-start my-5">
                <div className="bg-icon p-3 fw-bold purple-color me-3 fs-three-title">
                  <span className="d-block">{step.number}</span>
                </div>
                <div>
                  <h5 className="fw-bold fs-five-title anybody-font mb-1">
                    {step.title}
                  </h5>
                  <p className="fs-three gray-color mt-3 mb-0">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </Col>
          <Col md={6} className="text-center">
            <img
              src="/assets/Dashboard_1.png"
              alt="How it works"
              className="img-fluid mt-5"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Working;
